import React, { useState, useEffect } from 'react';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  TableSortLabel,
  Button,
  Grid2,
  TextField,
  MenuItem,
  Select,
  Box,
  Snackbar,
  Switch,
  Modal,
  IconButton,
  Divider
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CircularProgress from '@mui/material/CircularProgress';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useParams, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import TokenError from '../tokenError';
import config from '../../config/config.js';
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import constants from '../../constant.js'
import { Label } from 'flowbite-react';
import { borderRadius } from '@mui/system';

const DynamicRidesPanel = () => {
    
    const serverUrl = config.serverUrl;
    const autosUrl = config.autosUrl;
    const operationsUrl = config.operationsUrl;
    const { status } = useParams();
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState('');
    const [clientId] = useState(localStorage.getItem('clientId')); // Get clientId from localStorage or default to '1'

    const getHiddenColumns = () => {
        const clientConfig = constants.clientColumnConfig[clientId] || constants.clientColumnConfig['default'];
        return clientConfig[status] || clientConfig['default'] || [];
    };

    console.log(status,"status");
    const getVisibleColumns = (allColumns) => {
        const hiddenColumns = getHiddenColumns();
        return allColumns.filter(column => !hiddenColumns.includes(column.id));
    };

    const [columns, setColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [filters, setFilters] = useState({});
    const [filterValues, setFilterValues] = useState({});
    const [startDate, setStartDate] = useState(dayjs()); // Default: 7 days ago
    const [endDate, setEndDate] = useState(dayjs()); // Default: Today
    const [orderBy, setOrderBy] = useState('');
    const [order, setOrder] = useState('asc');
    const [modalOrderBy, setModalOrderBy] = useState('');
    const [modalOrder, setModalOrder] = useState('asc');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [filteredRows, setFilteredRows] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [updatingStatusFor, setUpdatingStatusFor] = useState(null);
    const [message, setMessage] = useState('');
    const [driverFilter, setDriverFilter] = useState('');

    const [customerIdFilter, setCustomerIdFilter] = useState('');
    const [ClientIdFilter, setClientIdFilter] = useState('');
    const [customerNameFilter, setCustomerNameFilter] = useState('');
    const [deliveryFilter, setDeliveryFilter] = useState(0);
  
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [isToday, setIsToday] = useState(false);
    const handleFilterChange = (filterType, value) => {
      if (filterType === 'city') setCityFilter(value);
      // if (filterType === 'status') setStatusFilter(value);
    };

    const [openMissedRidesDetails, setOpenMissedRidesDetails] = useState(false);
    const [modalColumns, setModalColumns] = useState([]);
    const [modalRows, setModalRows] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);

    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';
    const isDeliveryEnabled = localStorage.getItem('is_delivery_enabled');
    const isTripInvoiceVisible = localStorage.getItem('is_trip_invoice_visible');
    const [loading, setLoading] = useState(false);
    const [invoiceLoadingId, setInvoiceLoadingId] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [openPdfModal, setOpenPdfModal] = useState(false);
    const [pdfName, setPdfName] = useState('');
    const [merchantFilter, setMerchantFilter] = useState('');
    const merchantIdFromLocal = localStorage.getItem('merchantId') || 0;
    const hasMerchant = merchantIdFromLocal && merchantIdFromLocal !== '0' && merchantIdFromLocal !== 'undefined' && merchantIdFromLocal !== 'null';

    // Map statuses to human-readable names
    const reportNames = {
        ongoing: 'Ongoing Rides',
        completed: 'Completed Rides',
        cancelled: 'Cancelled Rides',
        timeout: 'Missed Rides',
        dispute: 'Disputed Rides',
    };
    
    const reportName = reportNames[status] || 'Rides Report';

    // Reset startDate and endDate when switching tabs
    // useEffect(() => {
    //     setCustomerIdFilter('');
    //     setCustomerNameFilter('');
    //     setClientIdFilter('');
    // }, [status]);
    
    const fetchData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const statusMapping = {
                ongoing: 1,
                completed: 2,
                cancelled: 3,
                timeout: 4,
                dispute: 2,
            };

            const selectedStatus = statusMapping[status] || 1;

            const url = `${serverUrl}/customer/fetch_trip_engagement`;

            // Prepare API payload
            const obj = {
                token,
                timestamp,
                start_date: startDate.format('YYYY-MM-DD'), // Format as needed by your API
                end_date: endDate.format('YYYY-MM-DD'),
                status: selectedStatus,
                is_dispute: status === 'dispute' ? 1 : 0,
                is_delivery: deliveryFilter == 1 ? 1 : 0
            };

            if(cityFilter){
                obj['city_id'] = cityFilter
            }

            const response =  await makeGetRequestToUrl(url, obj, null, 60000);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            const data = response.data;
            if (data && data.trip_engagement_details) {
            // Map API response to columns
            const columns = [
                { id: 'engagement_id', label: 'Engagement ID' },
                { id: 'request_id', label: 'Request ID' },
                { id: 'scheduled_id', label: 'Scheduled ID' },
                { id: 'user_id', label: 'User ID' },
                ...clientId === '188' ? [{ id: 'user_code', label: 'Client ID' }] : [],
                { id: 'user_name', label: 'User Name' },
                { id: 'driver_id', label: 'Driver ID' },
                { id: 'driver_name', label: 'Driver Name' },
                { id: 'driver_phone_number', label: 'Driver Phone Number' },
                { id: 'status', label: 'Status' },
                { id: 'client_vehicle_id', label: 'Client Vehicle ID' },
                { id: 'vehicle_type', label: 'Vehicle Type' },
                { id: 'payment_mode', label: 'Payment Mode'},
                { id: 'pickup_latitude', label: 'Pickup Latitude' },
                { id: 'pickup_longitude', label: 'Pickup Longitude' },
                { id: 'pickup_address', label: 'Pickup Address' },
                { id: 'drop_latitude', label: 'Drop Latitude' },
                { id: 'drop_longitude', label: 'Drop Longitude' },
                { id: 'drop_address', label: 'Drop Address' },
                { id: 'waypoints', label: 'Stops' },
                { id: 'ride_distance', label: 'Ride Distance (km)' },
                { id: 'ride_time', label: 'Ride Time (min)' },
                { id: 'estimated_fare', label: 'Estimated Fare' },
                { id: 'pickup_time', label: 'Pickup Time' },
                { id: 'driver_arrival_time', label: 'Driver Arrival Time' },
                { id: 'drop_time', label: 'Drop Time' },
                { id: 'model_name', label: 'Vehicle Name' },
                { id: 'vehicle_number', label: 'Vehicle Number' },

                { id: 'total_fare', label: 'Total Fare' },
                { id: 'driver_fare', label: 'Driver Fare' },
                { id: 'distance_fare', label: 'Distance Fare' },
                { id: 'time_fare', label: 'Time Fare' },
                { id: 'promo_name', label: 'Promo Name' },
                { id: 'discount_amount', label: 'Discount Amount' },
                { id: 'commission', label: 'Commission' },
                { id: 'platform_fee', label: 'Platform Fee' },
                ...(status === "cancelled" ? [{ id: 'cancellation_reason', label: 'Cancellation Reason' }] : []),
                ...(status === "cancelled" ? [{ id: 'cancellation_time', label: 'Cancellation Time' }] : []),
                ...(status === "cancelled" ? [{ id: 'refund_amount', label: 'Refund Amount' }] : []),
                ...(status === "cancelled" ? [{ id: 'actual_refund_amount', label: 'Actual Refund Amount' }] : []),
                ...(deliveryFilter == '0' ? [{ id: 'toll_charge', label: 'Toll Charge' }] : []),
                ...deliveryFilter == '0' ? [{ id: 'waiting_charges', label: 'Waiting Charges' }] : [],
                ...deliveryFilter == '0' ? [{ id: 'waiting_charges_driver_cut', label: 'Waiting Charges Driver Cut' }] : [],
                ...deliveryFilter == '0' ? [{ id: 'stops_waiting_charges', label: 'Stop Waiting Charges' }] : [],
                ...deliveryFilter == '0' ? [{ id: 'luggage_charges', label: 'Luggage Charges' }] : [],
                ...deliveryFilter == '0' ? [{ id: 'luggage_charges_driver_cut', label: 'Luggage Charges Driver Cut' }] : [],
                { id: 'convenience_fee', label: 'Convenince Fee' },
                { id: 'convenience_driver_cut', label: 'Convenince Driver Cut' },
                ...deliveryFilter == '0' ? [{ id: 'pickup_distance_charges', label: 'Pickup Distance Charges' }] : [],
                ...deliveryFilter == '0' ? [{ id: 'pickup_distance_charges_driver_cut', label: 'Pickup Distance Charges Driver Cut' }] : [],
                { id: 'tax', label: 'Tax' },
                ...(status === "completed" ? [{ id: 'customer_rating', label: 'Customer Rating' }] : []),
                { id: 'customer_review', label: 'Customer Review' },
                ...(status === "completed" ? [{ id: 'driver_rating', label: 'Driver Rating' }] : []),
                { id: 'driver_review', label: 'Driver Review' },
                ...deliveryFilter == '1' ? [{ id: 'size_fare', label: 'Size Fare' }] : [],
                ...deliveryFilter == '1' ? [{ id: 'weight_fare', label: 'Weight Fare' }] : [],
                { id: 'created_at', label: 'Created At' },
                ...(status === "dispute" ? [{ id: 'd_status', label: 'Dispute Status' }] : []),
                ...(status === "dispute" ? [{id: 'actions' , label: 'Actions' }] : []),
                ...(isTripInvoiceVisible == 1 && status === "completed" ? [{id: 'invoice' , label: 'Invoice' }] : []),
                ...(status === "timeout" ? [{ id: 'view_details', label: 'Action' }] : []),
            ];
    
            // Map rows from API response
            const rows = data.trip_engagement_details.map((item) => ({
                engagement_id: item.engagement_id,
                request_id: item.request_id,
                scheduled_id: item.scheduled_id,
                user_id: item.user_id,
                user_code: item.user_code,
                user_name: item.user_name,
                driver_id: item.driver_id,
                driver_name: item.driver_name,
                driver_phone_number: item.driver_phone_number,
                status: getEngagementStatusLabel(item.status),
                client_vehicle_id: item.client_vehicle_id,
                vehicle_type: item.vehicle_type==1 ? 'Taxi' : item.vehicle_type==2 ? 'Bike' : item.vehicle_type==3 ? 'Auto' : item.vehicle_type==4 ? 'Shuttle' : 'Unknown',
                payment_mode: constants.paymentMode[item.payment_mode || 1],
                pickup_latitude: parseFloat(item.pickup_latitude).toFixed(6),
                pickup_longitude: parseFloat(item.pickup_longitude).toFixed(6),
                pickup_address: item.pickup_address,
                drop_latitude: parseFloat(item.drop_latitude).toFixed(6),
                drop_longitude: parseFloat(item.drop_longitude).toFixed(6),
                drop_address: item.drop_address,
                waypoints: item.waypoints?.map(w => w.address).filter(Boolean).join(' | ') || '--',
                ride_distance: parseFloat(item.ride_distance).toFixed(2),
                ride_time: parseFloat(item.ride_time).toFixed(2),
                estimated_fare: parseFloat(item.estimated_fare).toFixed(2),
                pickup_time: item.pickup_time ? 
                (() => {
                    const pickupDate = new Date(item.pickup_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : '',
                driver_arrival_time: item.driver_arrival_time ? 
                (() => {
                    const pickupDate = new Date(item.driver_arrival_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : '',
                drop_time: item.drop_time ? 
                (() => {
                    const pickupDate = new Date(item.drop_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : '',
                model_name: item.model_name,
                vehicle_number: item.vehicle_number,

                total_fare: parseFloat(item.total_fare).toFixed(2),
                driver_fare: parseFloat(item.driver_fare).toFixed(2),
                distance_fare: parseFloat(item.distance_fare).toFixed(2),
                time_fare: parseFloat(item.time_fare).toFixed(2),
                promo_name: item.promo_name,
                discount_amount: parseFloat(item.discount_amount).toFixed(2),
                commission: parseFloat(item.commission).toFixed(2),
                platform_fee: parseFloat(item.platform_fee).toFixed(2),
                ...(status == "cancelled" ? { cancellation_reason: item.cancellation_reason || '--' } : {}),
                ...(status == "cancelled" ? { 
                    cancellation_time: item.cancellation_time ? 
                (() => {
                    const pickupDate = new Date(item.cancellation_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : ''
                } : {}),
                ...(status === "cancelled" ? { refund_amount: parseFloat(item.refund_amount).toFixed(2) } : {}),
                ...(status === "cancelled" ? { actual_refund_amount: parseFloat(item.actual_refund_amount).toFixed(2) } : {}),
                toll_charge: item.toll_charge,
                waiting_charges: item.waiting_charges,
                waiting_charges_driver_cut: item.waiting_charges_driver_cut,
                luggage_charges: item.luggage_charges,
                luggage_charges_driver_cut: item.luggage_charges_driver_cut,
                convenience_fee: parseFloat(item.convenience_fee).toFixed(2),
                convenience_driver_cut: parseFloat(item.convenience_driver_cut).toFixed(2),
                pickup_distance_charges: item.pickup_distance_charges,
                pickup_distance_charges_driver_cut: item.pickup_distance_charges_driver_cut,
                tax: parseFloat(item.tax).toFixed(2),
                ...(status === "completed"
                    ? {
                        customer_rating:
                        item.customer_rating === -1 || item.customer_rating === -2 || item.customer_rating == null
                            ? "N/A"
                            : item.customer_rating,
                    }
                    : {}),              customer_review: item.customer_review,
                ...(status === "completed"
                    ? {
                        driver_rating:
                        item.driver_rating === -1 || item.driver_rating === -2 || item.driver_rating == null
                            ? "N/A"
                            : item.driver_rating,
                    }
                    : {}),              driver_review: item.driver_review,
                size_fare: parseFloat(item.size_fare).toFixed(2),
                weight_fare: parseFloat(item.weight_fare).toFixed(2),
                merchant_id: item.merchant_id,
                merchant_name: item.merchant_name,
                created_at: item.created_at ? 
                (() => {
                    const pickupDate = new Date(item.created_at);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : '',
                d_status: item.dispute_status,
                dispute_status: item.dispute_status,
                action : item.dispute_status,
                ...(isTripInvoiceVisible && status === "completed" ? { invoice: item.invoice } : {}),
            }));
    
            setColumns(columns);
            setVisibleColumns(getVisibleColumns(columns));
            setRows(rows);
            // Respect current driver filter, if any
            const base = driverFilter ? rows.filter(r => String(r.driver_id ?? '') === String(driverFilter)) : rows;
            setFilteredRows(base);
            setPage(0);
            }
        } catch (error) {
            if (error.response?.status === 401) {
            setTokenExpired(true);
            } else {
            console.error('Error fetching data:', error);
            }
        }
    };

    const fetchMissedRidesData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const statusMapping = {
                ALIVE: 1,
                ACCEPTED: 2,
                timeout: 3,
                STARTED: 4,
                ENDED: 5,
                CANCELLED_BY_CUSTOMER: 6,
                CANCELLED_BY_DRIVER: 7,
                CANCELLED_BY_ADMIN: 8,
                CUSTOMER_NO_SHOW: 9,
                CANCELLED_BY_SYSTEM: 10,
                DRIVER_NO_SHOW: 11
            };

            const selectedStatus = statusMapping[status] || 1;

            const url = `${serverUrl}/customer/fetch_requested`;

            // Prepare API payload
            const obj = {
                token,
                timestamp,
                start_date: startDate.format('YYYY-MM-DD'), // Format as needed by your API
                end_date: endDate.format('YYYY-MM-DD'),
                status: selectedStatus,
                is_delivery: deliveryFilter == 1 ? 1 : 0
            };

            if(cityFilter){
                obj['city_id'] = cityFilter
            }

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            const data = response.data;
            if (data && data.trip_request_details) {
            // Map API response to columns
            const columns = [
                { id: 'request_id', label: 'Request ID' },
                { id: 'scheduled_id', label: 'Scheduled ID' },
                { id: 'user_id', label: 'User ID' },
                ...clientId === '188' ? [{ id: 'user_code', label: 'Client ID' }] : [],
                { id: 'user_name', label: 'User Name' },
                { id: 'status', label: 'Status' },
                { id: 'client_vehicle_id', label: 'Client Vehicle ID' },
                { id: 'vehicle_type', label: 'Vehicle Type' },
                { id: 'payment_mode', label: 'Payment Mode'},
                { id: 'pickup_latitude', label: 'Pickup Latitude' },
                { id: 'pickup_longitude', label: 'Pickup Longitude' },
                { id: 'pickup_address', label: 'Pickup Address' },
                { id: 'drop_latitude', label: 'Drop Latitude' },
                { id: 'drop_longitude', label: 'Drop Longitude' },
                { id: 'drop_address', label: 'Drop Address' },
                { id: 'waypoints', label: 'Stops' },
                { id: 'ride_distance', label: 'Ride Distance (km)' },
                { id: 'ride_time', label: 'Ride Time (min)' },
                { id: 'estimated_fare', label: 'Estimated Fare' },
                { id: 'pickup_time', label: 'Pickup Time' },
                { id: 'created_at', label: 'Created At' },
                ...(isTripInvoiceVisible == 1 && status === "completed" ? [{id: 'invoice' , label: 'Invoice' }] : []),
                ...(status === "timeout" ? [{ id: 'view_details', label: 'Action' }] : []),
            ];
    
            // Map rows from API response
            const rows = data.trip_request_details.map((item) => ({
                engagement_id: item.engagement_id,
                request_id: item.request_id,
                scheduled_id: item.scheduled_id,
                user_id: item.user_id,
                user_code: item.user_code,
                user_name: item.user_name,
                driver_id: item.driver_id,
                driver_name: item.driver_name,
                driver_phone_number: item.driver_phone_number,
                status: 'Missed',
                client_vehicle_id: item.client_vehicle_id,
                vehicle_type: item.vehicle_type==1 ? 'Taxi' : item.vehicle_type==2 ? 'Bike' : item.vehicle_type==3 ? 'Auto' : item.vehicle_type==4 ? 'Shuttle' : 'Unknown',
                payment_mode: constants.paymentMode[item.payment_mode || 1],
                pickup_latitude: parseFloat(item.pickup_latitude).toFixed(6),
                pickup_longitude: parseFloat(item.pickup_longitude).toFixed(6),
                pickup_address: item.pickup_address,
                drop_latitude: parseFloat(item.drop_latitude).toFixed(6),
                drop_longitude: parseFloat(item.drop_longitude).toFixed(6),
                drop_address: item.drop_address,
                waypoints: item.waypoints?.map(w => w.address).filter(Boolean).join(' | ') || '--',
                ride_distance: parseFloat(item.ride_distance).toFixed(2),
                ride_time: parseFloat(item.ride_time).toFixed(2),
                estimated_fare: parseFloat(item.estimated_fare).toFixed(2),
                pickup_time: item.pickup_time ? 
                (() => {
                    const pickupDate = new Date(item.pickup_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : '',
                driver_arrival_time: item.driver_arrival_time ? 
                (() => {
                    const pickupDate = new Date(item.driver_arrival_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : '',
                drop_time: item.drop_time ? 
                (() => {
                    const pickupDate = new Date(item.drop_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : '',
                model_name: item.model_name,
                vehicle_number: item.vehicle_number,

                total_fare: parseFloat(item.total_fare).toFixed(2),
                driver_fare: parseFloat(item.driver_fare).toFixed(2),
                distance_fare: parseFloat(item.distance_fare).toFixed(2),
                time_fare: parseFloat(item.time_fare).toFixed(2),
                promo_name: item.promo_name,
                discount_amount: parseFloat(item.discount_amount).toFixed(2),
                commission: parseFloat(item.commission).toFixed(2),
                platform_fee: parseFloat(item.platform_fee).toFixed(2),
                ...(status == "cancelled" ? { cancellation_reason: item.cancellation_reason || '--' } : {}),
                ...(status == "cancelled" ? { 
                    cancellation_time: item.cancellation_time ? 
                (() => {
                    const pickupDate = new Date(item.cancellation_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : ''
                } : {}),
                ...(status === "cancelled" ? { refund_amount: parseFloat(item.refund_amount).toFixed(2) } : {}),
                ...(status === "cancelled" ? { actual_refund_amount: parseFloat(item.actual_refund_amount).toFixed(2) } : {}),
                toll_charge: item.toll_charge,
                waiting_charges: item.waiting_charges,
                waiting_charges_driver_cut: item.waiting_charges_driver_cut,
                luggage_charges: item.luggage_charges,
                luggage_charges_driver_cut: item.luggage_charges_driver_cut,
                convenience_fee: parseFloat(item.convenience_fee).toFixed(2),
                convenience_driver_cut: parseFloat(item.convenience_driver_cut).toFixed(2),
                pickup_distance_charges: item.pickup_distance_charges,
                pickup_distance_charges_driver_cut: item.pickup_distance_charges_driver_cut,
                tax: parseFloat(item.tax).toFixed(2),
                ...(status === "completed"
                    ? {
                        customer_rating:
                        item.customer_rating === -1 || item.customer_rating === -2 || item.customer_rating == null
                            ? "N/A"
                            : item.customer_rating,
                    }
                    : {}),              customer_review: item.customer_review,
                ...(status === "completed"
                    ? {
                        driver_rating:
                        item.driver_rating === -1 || item.driver_rating === -2 || item.driver_rating == null
                            ? "N/A"
                            : item.driver_rating,
                    }
                    : {}),              driver_review: item.driver_review,
                size_fare: parseFloat(item.size_fare).toFixed(2),
                weight_fare: parseFloat(item.weight_fare).toFixed(2),
                created_at: item.created_at ? 
                (() => {
                    const pickupDate = new Date(item.created_at);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: timeZoneFormat == '12' ? true : false,
                    timeZone: 'UTC'
                    }).replace(',', ' |');
                })() 
                : '',
                d_status: item.dispute_status,
                dispute_status: item.dispute_status,
                action : item.dispute_status,
                ...(isTripInvoiceVisible && status === "completed" ? { invoice: item.invoice } : {}),
            }));
    
            setColumns(columns);
            setVisibleColumns(getVisibleColumns(columns));
            setRows(rows);
            // Respect current driver filter, if any
            const base = driverFilter ? rows.filter(r => String(r.driver_id ?? '') === String(driverFilter)) : rows;
            setFilteredRows(base);
            setPage(0);
            }
        } catch (error) {
            if (error.response?.status === 401) {
            setTokenExpired(true);
            } else {
            console.error('Error fetching data:', error);
            }
        }
    };

    const fetchEngagementByRequestId = async (requestId) => {
        setModalLoading(true);
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
    
            const url = `${serverUrl}/customer/fetch_trip_engagement`;
    
            const obj = {
                token,
                timestamp,
                start_date: startDate.format('YYYY-MM-DD'),
                end_date: endDate.format('YYYY-MM-DD'),
                status: 4,
                is_dispute: 0,
                is_delivery: deliveryFilter == 1 ? 1 : 0,
                request_id: requestId,
            };
            if (cityFilter) obj['city_id'] = cityFilter;
    
            const response = await makeGetRequestToUrl(url, obj, null, 60000);
    
            if (response.flag == 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => navigate('/signup'), 2000);
                return;
            }
    
            const data = response.data;
            if (data && data.trip_engagement_details) {
                const cols = [
                    { id: 'engagement_id', label: 'Engagement ID' },
                    { id: 'request_id', label: 'Request ID' },
                    { id: 'user_id', label: 'User ID' },
                    ...(clientId === '188' ? [{ id: 'user_code', label: 'Client ID' }] : []),
                    { id: 'user_name', label: 'User Name' },
                    { id: 'driver_id', label: 'Driver ID' },
                    { id: 'driver_name', label: 'Driver Name' },
                    { id: 'driver_phone_number', label: 'Driver Phone Number' },
                    { id: 'status', label: 'Status' },
                    { id: 'vehicle_type', label: 'Vehicle Type' },
                    { id: 'payment_mode', label: 'Payment Mode' },
                    { id: 'pickup_address', label: 'Pickup Address' },
                    { id: 'drop_address', label: 'Drop Address' },
                    { id: 'waypoints', label: 'Stops' },
                    { id: 'ride_distance', label: 'Ride Distance (km)' },
                    { id: 'ride_time', label: 'Ride Time (min)' },
                    { id: 'estimated_fare', label: 'Estimated Fare' },
                    { id: 'pickup_time', label: 'Pickup Time' },
                    { id: 'driver_arrival_time', label: 'Driver Arrival Time' },
                    { id: 'drop_time', label: 'Drop Time' },
                    { id: 'model_name', label: 'Vehicle Name' },
                    { id: 'vehicle_number', label: 'Vehicle Number' },
                    { id: 'total_fare', label: 'Total Fare' },
                    { id: 'driver_fare', label: 'Driver Fare' },
                    { id: 'created_at', label: 'Created At' },
                ];
    
                const formatDate = (value) => {
                    if (!value) return '';
                    const d = new Date(value);
                    d.setMinutes(d.getMinutes() + utcOffset);
                    return d.toLocaleString('en-GB', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit',
                        hour12: timeZoneFormat == '12',
                        timeZone: 'UTC',
                    }).replace(',', ' |');
                };
    
                const mapped = data.trip_engagement_details.map((item) => ({
                    engagement_id: item.engagement_id,
                    request_id: item.request_id,
                    user_id: item.user_id,
                    user_code: item.user_code,
                    user_name: item.user_name,
                    driver_id: item.driver_id,
                    driver_name: item.driver_name,
                    driver_phone_number: item.driver_phone_number,
                    status: getEngagementStatusLabel(item.status),
                    vehicle_type: item.vehicle_type == 1 ? 'Taxi' : item.vehicle_type == 2 ? 'Bike' : item.vehicle_type == 3 ? 'Auto' : item.vehicle_type == 4 ? 'Shuttle' : 'Unknown',
                    payment_mode: constants.paymentMode[item.payment_mode || 1],
                    pickup_address: item.pickup_address,
                    drop_address: item.drop_address,
                    waypoints: item.waypoints?.map(w => w.address).filter(Boolean).join(' | ') || '--',
                    ride_distance: parseFloat(item.ride_distance).toFixed(2),
                    ride_time: parseFloat(item.ride_time).toFixed(2),
                    estimated_fare: parseFloat(item.estimated_fare).toFixed(2),
                    pickup_time: formatDate(item.pickup_time),
                    driver_arrival_time: formatDate(item.driver_arrival_time),
                    drop_time: formatDate(item.drop_time),
                    model_name: item.model_name,
                    vehicle_number: item.vehicle_number,
                    total_fare: parseFloat(item.total_fare).toFixed(2),
                    driver_fare: parseFloat(item.driver_fare).toFixed(2),
                    created_at: formatDate(item.created_at),
                }));
    
                setModalColumns(cols);
                setModalRows(mapped);
            } else {
                setModalColumns([]);
                setModalRows([]);
            }
        } catch (error) {
            console.error('Error fetching engagement details:', error);
            setModalColumns([]);
            setModalRows([]);
        } finally {
            setModalLoading(false);
        }
    };

    // useEffect(() => {
    //     if (startDate && endDate) {
    //         if(status=='timeout'){
    //             fetchMissedRidesData();
    //         }
    //         else{
    //             fetchData();
    //         }
    //     }
    // }, [startDate, endDate, cityFilter, deliveryFilter]);
    const startKey = startDate?.format('YYYY-MM-DD');
    const endKey = endDate?.format('YYYY-MM-DD');

    useEffect(() => {
        if (!startKey || !endKey) return;
        if (status === 'timeout') fetchMissedRidesData();
        else fetchData();
    }, [startKey, endKey, cityFilter, deliveryFilter, status]);

      // const fetchInvoice = async (engagementid, userid) => {
      //   try {
      //     const token = localStorage.getItem('token');

      //     const payload = {
      //       user_access_token: token,
      //       user_id: userid,
      //       trip_engagement_id: engagementid,
      //       is_panel_request: 1,
      //     };

      //     const url = `${autosUrl}/customer/send_invoice_to_mail`;
      //     const response = await makePostRequestToUrl(url, payload);

      //     if (response?.data?.pdf_buffer?.data) {
      //       const byteArray = new Uint8Array(response.data.pdf_buffer.data);

      //       const blob = new Blob([byteArray], { type: 'application/pdf' });

      //       const fileURL = URL.createObjectURL(blob);

      //       setPdfUrl(fileURL);
      //       setPdfName(response.data.pdf_filename);
      //       setOpenPdfModal(true);
      //     }
      //   } catch (error) {
      //     console.error(error);
      //   }
      // };


    const fetchInvoice = async (engagementid, userid) => {
        try {
            setInvoiceLoadingId(engagementid); // 🔥 start loading

            const token = localStorage.getItem('token');

            const payload = {
                user_access_token: token,
                user_id: userid,
                trip_engagement_id: engagementid,
                is_panel_request: 1,
            };

            const url = `${autosUrl}/customer/send_invoice_to_mail`;
            const response = await makePostRequestToUrl(url, payload);

            if (response?.data?.pdf_buffer?.data) {
                const byteArray = new Uint8Array(response.data.pdf_buffer.data);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(blob);

                setPdfUrl(fileURL);
                setPdfName(response.data.pdf_filename);
                setOpenPdfModal(true);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setInvoiceLoadingId(null); // 🔥 stop loading
        }
    };
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...filteredRows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        // setRows(sortedRows);
        setFilteredRows(sortedRows);
    };

    const handleModalRequestSort = (property) => {
        const isAscending = modalOrderBy === property && modalOrder === 'asc';
        const newOrder = isAscending ? 'desc' : 'asc';
        setModalOrder(newOrder);
        setModalOrderBy(property);
    
        const sorted = [...modalRows].sort((a, b) => {
            let aVal = a[property];
            let bVal = b[property];
    
            // Numeric-aware comparison (fares, distances etc. are strings like "12.50")
            const aNum = parseFloat(aVal);
            const bNum = parseFloat(bVal);
            if (!isNaN(aNum) && !isNaN(bNum)) {
                aVal = aNum;
                bVal = bNum;
            }
    
            if (aVal < bVal) return newOrder === 'asc' ? -1 : 1;
            if (aVal > bVal) return newOrder === 'asc' ? 1 : -1;
            return 0;
        });
        setModalRows(sorted);
    };

    const handleDisputeStatus = async (row, action) => {
        setUpdatingStatusFor(row.engagement_id);
        const token = localStorage.getItem('token');
        const payload = {
            token : token,
            engagement_id: row.engagement_id,
            dispute_status : action === 'accept' ? 2 : 3,
        }
        try {
            const url = operationsUrl + '/panel/update_dispute_trip_status';
            const response = await makePostRequestToUrl(url, payload);
            if(response.flag == 200){
                const msg = `Dispute status updated to ${action === 'accept' ? 'Approved' : 'Rejected'} for Engagement ID: ${row.engagement_id}`;
                fetchData();
                setSnackbarMsg(response.message || msg);
                setSnackbarOpen(true);
            }else if(response.flag==102){
                localStorage.removeItem('token');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            } else {
                setMessage(response.message);
            }
        }
        catch(error){
            console.error('Error', error);
            setMessage(error);
        } 
        finally{
            setUpdatingStatusFor(null);
        }
    }

    const handleInvoiceStatus = async(row)=>{
        await fetchInvoice(row.engagement_id,row.user_id)
    }

    const getEngagementStatusLabel = (statusCode) => {
        // Create reverse mapping from taxiEngagementStatus
        const statusMap = {
            1: 'Alive',
            2: 'Accepted',
            3: 'Arrived',
            4: 'Missed', //timeout
            5: 'Started',
            6: 'Ended',
            7: 'Rejected By Driver',
            8: 'Cancelled By Customer',
            9: 'Cancelled By Driver',
            10: 'Cancelled By Admin',
            11: 'Reverse Bid Initiated By Driver',
            12: 'Rejected By Customer',
            13: 'Customer No Show',
            14: 'Cancelled By System',
            15: 'Driver No Show'
        };
        
        return statusMap[statusCode] || 'UNKNOWN';
    };

    const getEngagementStatusColor = (statusCode) => {
        // Color mapping for different status codes
        console.log(statusCode)
        const colorMap = {
            'Alive': '#808080', // Gray for ALIVE
            'Accepted': '#0065ff', // blue for ACCEPTED
            'Arrived': '#F5BB19', // Yellow for ARRIVED
            'Timeout': '#D14545', // Red for TIMEOUT
            'Started': '#F5BB19', // Yellow for STARTED
            'Ended': '#0DBA78', // Green for ENDED
            'Rejected By Driver': '#D14545', // Red for REJECTED BY DRIVER
            'Cancelled By Customer': '#FFA500', // orange for CANCELLED BY CUSTOMER
            'Cancelled By Driver': '#FFA500',  // orange for CANCELLED BY DRIVER
            'Cancelled By Admin': '#FFA500',  // orange for CANCELLED BY DRIVER
            'Cancelled By System': '#FFA500',  
            'Customer No Show': '#ac7103',
            'Reverse Bid Initiated By Driver' : '#0DBA78',
            'Rejected By Customer' : '#FFA500',
            'Driver No Show' : '#ac7103',
            'Missed': '#D14545'
        };
        
        return colorMap[statusCode] || '#000000'; // Default black
    };

    useEffect(() => {
        const paginated = Array.isArray(filteredRows)
            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [filteredRows, page, rowsPerPage]);

    // const handleFilterChange = (key, value) => {
    //     setFilterValues((prev) => ({ ...prev, [key]: value }));
    // };

    const handleChangePage = (newPage) => setPage(newPage);

    const handleDriverFilterChange = (value) => {
        setDriverFilter(value);
        let base = rows;
        if (value) {
            base = rows.filter(r => String(r.driver_id ?? '') === String(value));
        }
        setFilteredRows(base);
        setPage(0);
    };

    // Merchant filter: re-derives the table from `rows` using the existing driver/customer filters + merchant
    const applyMerchantFilter = (value, baseRows) => {
        let data = [...baseRows];
        if (driverFilter) data = data.filter(r => String(r.driver_id ?? '') === String(driverFilter));
        if (customerIdFilter) data = data.filter(r => r.user_id && r.user_id.toString().includes(customerIdFilter));
        if (customerNameFilter) data = data.filter(r => r.user_name && r.user_name.toString().toLowerCase().includes(customerNameFilter.toLowerCase()));
        if (ClientIdFilter) data = data.filter(r => r.user_code && r.user_code.toString().toLowerCase().includes(ClientIdFilter.toLowerCase()));
        if (value) {
            data = data.filter(r => value === 'none'
                ? !r.merchant_id
                : String(r.merchant_id) === String(value));
        }
        return data;
    };

    const handleMerchantFilterChange = (value) => {
        setMerchantFilter(value);
        setFilteredRows(applyMerchantFilter(value, rows));
        setPage(0);
    };

    // When new data is fetched, keep the merchant filter applied
    useEffect(() => {
        if (merchantFilter) setFilteredRows(applyMerchantFilter(merchantFilter, rows));
    }, [rows]);

    const sortedRows = [...rows].sort((a, b) => {
        if (!orderBy) return 0;
        return (a[orderBy] < b[orderBy] ? -1 : 1) * (order === 'asc' ? 1 : -1);
    });

    const handleExportCsv = () => {
        const exportColumns = visibleColumns.filter((c) => c.id !== 'view_details');
        const headers = exportColumns.map((col) => col.label).join(',');
        
        // Process each row for CSV export
        const csvRows = rows.map((row) => {
            return exportColumns.map((col) => {
                // Special handling for waypoints column
                if (col.id === 'waypoints' && Array.isArray(row.originalWaypoints)) {
                    // Convert waypoints to a readable text format for CSV
                    const waypointsText = row.originalWaypoints
                        .map((waypoint, idx) => `Stop ${idx + 1}: ${waypoint.address || 'No address'}`)
                        .join('; ');
                    return `"${waypointsText}"`;
                }
                return `"${row[col.id] || ''}"`;  
            }).join(',');
        });
        
        const csvContent = [headers, ...csvRows].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${reportName}.csv`;
        link.click();
    };

    const handleModalExportCsv = () => {
        if (!modalRows.length) return;
    
        const headers = modalColumns.map((col) => col.label).join(',');
    
        const csvRows = modalRows.map((row) =>
            modalColumns
                .map((col) => `"${String(row[col.id] ?? '').replace(/"/g, '""')}"`)
                .join(',')
        );
    
        const csvContent = [headers, ...csvRows].join('\n');
    
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Engagement Details.csv`;
        link.click();
    };

    useEffect(() => {
        if (columns.length > 0) {
            setVisibleColumns(getVisibleColumns(columns));
        }
    }, [clientId, columns, status]);

    const handleCustomerIdChange = (e) => {
        const value = e.target.value;
        setCustomerIdFilter(value);
        setPage(0);
        
        // Clear notificationRideId when customer ID changes
        if (value) {
            setCustomerNameFilter('');
        }
        
        if (rows && rows.length > 0) {
            const filteredData = value 
                ? rows.filter(item => item.user_id && item.user_id.toString().includes(value))
                : [...rows]; // Reset to all rows if value is empty
            setFilteredRows(filteredData);
        }
    }

    const handleClientIdFilter = (e) =>{
        const value = e.target.value;
        setClientIdFilter(value);
        setPage(0);
        if (value) {
            setCustomerNameFilter('');
            setCustomerIdFilter('');
        }
        
        if (rows && rows.length > 0) {
            const filteredData = value 
                ? rows.filter(item => item.user_code && item.user_code.toString().toLowerCase().includes(value.toLowerCase()))
                : [...rows];
            setFilteredRows(filteredData);
        }
    }

    const handleCustomerNameChange = (e) => {
        const value = e.target.value;
        setCustomerNameFilter(value);
        setPage(0);

        if (value) {
            setCustomerIdFilter('');
        }
        
        if (rows && rows.length > 0) {
            const filteredData = value 
                ? rows.filter(item => item.user_name && item.user_name.toString().toLowerCase().includes(value.toLowerCase()))
                : [...rows]; // Reset to all rows if value is empty
            setFilteredRows(filteredData);
        }
    }

    useEffect(() => {
        setStartDate(dayjs());
        setEndDate(dayjs());
        setCustomerIdFilter('');
        setCustomerNameFilter('');
        setClientIdFilter('');
        setMerchantFilter('');
    }, [status]);

    useEffect(() => {
        setPage(0);
    }, [customerIdFilter, customerNameFilter, ClientIdFilter]);

    const handleViewDetails = (row) => {
        setModalColumns([]);
        setModalRows([]);
        setModalOrderBy('');
        setModalOrder('asc');
        setOpenMissedRidesDetails(true);
        fetchEngagementByRequestId(row.request_id);
    };

    return (
        <div>
            {tokenExpired && <TokenError />}

            <Typography style={{ fontSize: '28px', fontWeight: '500', marginBottom: '20px' }}>{reportName}</Typography>

            {/* Dynamic Filters */}
            <Grid2 container spacing={1.8} alignItems="center" style={{ marginBottom: '20px' }}>

            <Grid2 item>
                <Select
                    value={cityFilter}
                    onChange={(e) => handleFilterChange('city', e.target.value)}
                    displayEmpty
                    style={{
                        width: '170px',
                        height: '50px',
                        borderRadius: '8px',
                        backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                    }}
                >
                    <MenuItem value="">All</MenuItem>
                    {cities.map((city) => (
                        <MenuItem key={city.city_id} value={city.city_id}>
                            {city.city_name}
                        </MenuItem>
                    ))}
                </Select>
            </Grid2>

            {/* Start Date Filter */}
            <Grid2 item>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Start Date"
                        slotProps={{ 
                            textField: { 
                                size: 'small',
                            } 
                        }}
                        sx={{
                            width: '160px',
                            '& .MuiInputBase-root': {
                                minHeight: '44px',
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                marginTop:'4px',
                                minWidth:'160px'
                            }
                        }}
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        renderInput={(params) => <TextField {...params} style={{ width: '200px' }} />}
                        disabled={isToday}
                    />
                </LocalizationProvider>
            </Grid2>
            {/* End Date Filter */}
            <Grid2 item>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="End Date"
                        slotProps={{ 
                            textField: { 
                                size: 'small',
                            } 
                        }}
                        sx={{
                            width: '160px',
                            '& .MuiInputBase-root': {
                                minHeight: '44px',
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                marginTop:'4px',
                                minWidth:'160px'
                            }
                        }}
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        renderInput={(params) => <TextField {...params} style={{ width: '200px' }} />}
                        disabled={isToday}
                    />
                </LocalizationProvider>
            </Grid2>
            {/* Driver Filter */}
            <Grid2 item>
                <Select
                    value={driverFilter}
                    onChange={(e) => handleDriverFilterChange(e.target.value)}
                    displayEmpty
                    style={{
                        width: '170px',
                        height: '48px',
                        borderRadius: '8px',
                        backgroundColor: '#FFFFFF',
                    }}
                >
                    <MenuItem value="" sx={{fontSize:'14px'}}>All Drivers</MenuItem>
                    {Array.from(
                        new Map(
                            (rows || [])
                                .filter(r => r && r.driver_id !== null && r.driver_id !== undefined && r.driver_id !== '')
                                .map(r => [String(r.driver_id), r.driver_name || `Driver ${r.driver_id}`])
                        ).entries()
                    ).map(([id, name]) => (
                        <MenuItem key={id} value={id} sx={{fontSize:'14px'}}>{name} <span style={{color:'#AC8312', marginLeft:"4px"}}> (ID: {id})</span></MenuItem>
                    ))}
                </Select>
            </Grid2>

            {!hasMerchant && (rows || []).some(r => r?.merchant_id) &&
                <Grid2 item>
                    <Select
                        value={merchantFilter}
                        onChange={(e) => handleMerchantFilterChange(e.target.value)}
                        displayEmpty
                        style={{ width: '190px', height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF' }}
                    >
                        <MenuItem value="" sx={{fontSize:'14px'}}>All Merchants</MenuItem>
                        {Array.from(
                            new Map(
                                (rows || [])
                                    .filter(r => r && r.merchant_id)
                                    .map(r => [String(r.merchant_id), r.merchant_name || `Merchant ${r.merchant_id}`])
                            ).entries()
                        ).map(([id, name]) => (
                            <MenuItem key={id} value={id} sx={{fontSize:'14px'}}>
                                {name} <span style={{color:'#AC8312', marginLeft:'4px'}}>(ID: {id})</span>
                            </MenuItem>
                        ))}
                        <MenuItem value="none" sx={{fontSize:'14px'}}>No Merchant (regular rides)</MenuItem>
                    </Select>
                </Grid2>
            }

            <Grid2 xs="auto">
                {/* <Label>Customer Id:</Label><br/> */}
                <input type="number" placeholder="Customer Id" className='filterBtn' value={customerIdFilter} onChange={handleCustomerIdChange} min="0"
                    onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                        e.preventDefault();
                        }
                    }}
                    style={{
                        width: '170px',
                        height: '48px',
                        borderRadius: '8px',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #d2d1d1ff',
                    }}
                />
            </Grid2>

            {clientId == 188 && 
            <Grid2 xs="auto">
                <input placeholder="Client Id" className='filterBtn' value={ClientIdFilter} onChange={handleClientIdFilter}
                    style={{
                        width: '170px',
                        height: '48px',
                        borderRadius: '8px',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #d2d1d1ff',
                    }}
                />
            </Grid2>
            }

            <Grid2 xs="auto">
                {/* <Label>Customer Name:</Label><br/> */}
                <input type="text" placeholder="Customer Name" className='filterBtn' value={customerNameFilter} onChange={handleCustomerNameChange} min="0"
                style={{
                    width: '170px',
                    height: '48px',
                    borderRadius: '8px',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #d2d1d1ff'
                }}
                />
            </Grid2>

            {isDeliveryEnabled != 0 && 
            <Grid2 xs="auto" sx={{border:'1px solid #CCCDCE', borderRadius:'8px', display:'flex', alignItems:'center', backgroundColor:'#fff', width:'150px', height:'48px'}}>
                <Typography sx={{marginLeft:'8px'}}>Delivery:</Typography>
                <Switch
                    checked={deliveryFilter}
                    onChange={(e) => setDeliveryFilter(e.target.checked)}
                />
            </Grid2>
            }

            <Grid2 item sx={{display:'flex', alignItems:'center', border:isToday ? '1px solid #0065ff' : '1px solid gray', borderRadius:'8px', padding:'4px 8px', backgroundColor:'#fff'}}>
                <Typography sx={{color: isToday ? '#0065ff' : '#000'}}>Today :</Typography>
                <Switch checked={isToday} 
                    onChange={(e) => {
                        setIsToday(e.target.checked)
                        if(e.target.checked){
                            setStartDate(dayjs());
                            setEndDate(dayjs());
                        }
                        else{
                            setStartDate(dayjs());
                            setEndDate(dayjs());
                        }
                    }} 
                    inputProps={{ 'aria-label': 'controlled' }} 
                />
            </Grid2>

            {/* Export CSV Button */}
            <Grid2 item>
                <Button variant="contained" onClick={handleExportCsv}
                    style={{marginLeft: '16px', backgroundColor: '#0065FF',color: 'white', height: '48px', boxShadow:'none', borderRadius:'8px'}}
                >
                Export CSV
                </Button>
            </Grid2>
        </Grid2>


        {/* Data Table */}
        <TableContainer className="table-container" style={{ maxHeight: 'calc(100vh - 280px)', overflow: 'auto'  }}>
            <Table stickyHeader className="scrollable-table">
                <TableHead>
                    <TableRow>
                        {visibleColumns.map((col) => (
                            <TableCell key={col.id} align="center" className="table-header" style={{ minWidth: col.id === 'waypoints' ? '310px' : 'auto' }}>
                                <TableSortLabel
                                    active={orderBy === col.id}
                                    direction={orderBy === col.id ? order : 'asc'}
                                    onClick={() => handleRequestSort(col.id)}
                                >
                                    {col.label}
                                </TableSortLabel>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paginatedData.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={visibleColumns.length} align="left">
                                No data available
                            </TableCell>
                        </TableRow>
                    ) : (
                    paginatedData.map((row, index) => (
                        <TableRow key={index}>
                            {visibleColumns.map((col) => (
                                <TableCell key={col.id} align="center">
                                    {col.id === 'd_status' ? (
                                    row.dispute_status == 1 ? (
                                    <Button variant="contained" color="warning" size="small" sx={{textTransform:'none', boxShadow:'none'}}>Pending</Button>
                                    ) : row.dispute_status === 2 ? (
                                    <Button variant="contained" color="success" size="small" sx={{textTransform:'none', boxShadow:'none'}}>Approved</Button>
                                    ) : row.dispute_status === 3 ? (
                                    <Button variant="contained" color="error" size="small" sx={{textTransform:'none', boxShadow:'none'}}>Rejected</Button>
                                    ) : (
                                    'N/A'
                                    )
                                ) : col.id === 'actions' ? (
                                    row.dispute_status == 1 ? (<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
                                    <Button
                                        onClick={() => handleDisputeStatus(row, 'accept')}
                                        variant="contained"
                                        disabled={updatingStatusFor === row.engagement_id}
                                        sx={{
                                        backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                        borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "90px",
                                        '&:hover': { backgroundColor: '#0DBA78', color: 'white' },
                                        marginRight:'4px',
                                        '&.Mui-disabled': {
                                            backgroundColor: '#BDBDBD',
                                            color: 'white',
                                            border: '1px solid #BDBDBD'
                                        }
                                        }}
                                    >
                                        <Typography sx={{ marginRight: '6%' }}>Accept</Typography>
                                    </Button>
            
                                    <Button
                                        onClick={() => handleDisputeStatus(row, 'reject')}
                                        disabled={updatingStatusFor === row.engagement_id}
                                        sx={{
                                        color: '#D14545', border: '1px solid #D14545', textTransform: 'none',
                                        borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "90px",
                                        '&:hover': { backgroundColor: '#D14545', color: 'white' },
                                        marginRight:'4px',
                                        '&.Mui-disabled': {
                                            backgroundColor: '#BDBDBD',
                                            color: 'white',
                                            border: '1px solid #BDBDBD'
                                        }
                                        }}
                                    >
                                        <Typography sx={{ marginRight: '6%' }}>Reject</Typography>
                                    </Button>
                                    </Box>) :('N/A')
                                ) : 
                                col.id === 'invoice' ? (
                                status === "completed" && (
                                    <Button
                                    onClick={() => handleInvoiceStatus(row)}
                                    disabled={invoiceLoadingId === row.engagement_id}
                                    sx={{
                                        minWidth: '40px',
                                        padding: '6px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFECEC',
                                        color: '#D32F2F',
                                        '&:hover': {
                                        backgroundColor: '#D32F2F',
                                        color: '#fff'
                                        }
                                    }}
                                    >
                                    {invoiceLoadingId === row.engagement_id ? (
                                        <CircularProgress size={20} sx={{ color: '#D32F2F' }} />
                                    ) : (
                                        <PictureAsPdfIcon />
                                    )}
                                    </Button>
                                )
                                ) 
                                : col.id === 'view_details' ? (
                                <Button
                                    onClick={() => handleViewDetails(row)}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                    boxShadow: 'none',
                                    whiteSpace: 'nowrap',
                                    color: '#0065FF',
                                    border: '1px solid #0065FF',
                                    '&:hover': { backgroundColor: '#0065FF', color: '#fff' }
                                    }}
                                >
                                    View Details
                                </Button>
                                )
                                : col.id === 'status' ? (
                                    <Typography 
                                    sx={{ 
                                        fontWeight: 'medium', 
                                        color: getEngagementStatusColor(row.status),
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        display: 'inline-block',
                                        // backgroundColor: `${getEngagementStatusColor(row.status)}15` // Using 15% opacity of the color for background
                                    }}
                                    >
                                    {row[col.id]}
                                    </Typography>
                                ) : (
                                    row[col.id] || 'N/A'
                                )}
                                </TableCell>
                            ))}
                        </TableRow>
                    )))}
                </TableBody>
            </Table>

            {/* Pagination */}
            <div className="custom-pagination">
                <div className="pagination-info">
                    {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                    (page + 1) * rowsPerPage,
                    filteredRows.length
                    )} of ${filteredRows.length} entries`}
                </div>
                <div className="pagination-controls">
                    <button
                    onClick={() => handleChangePage(page - 1)}
                    disabled={page === 0}
                    className="pagination-arrow"
                    >
                    <img src={prevIcon} alt="Previous" />
                    </button>
                    <div className="pagination-numbers">
                    {page > 1 && (
                        <>
                        <button onClick={() => handleChangePage(0)} className="pagination-number">
                            1
                        </button>
                        <span className="pagination-dots">...</span>
                        </>
                    )}
                    {[...Array(Math.ceil(filteredRows.length / rowsPerPage))]
                        .map((_, index) => index)
                        .filter((index) => index >= page - 1 && index <= page + 1) // Show only current, previous, and next pages
                        .map((index) => (
                        <button
                            key={index}
                            onClick={() => handleChangePage(index)}
                            className={`pagination-number ${page === index ? 'active' : ''}`}
                        >
                            {index + 1}
                        </button>
                        ))}
                    {page < Math.ceil(filteredRows.length / rowsPerPage) - 2 && (
                        <>
                        <span className="pagination-dots">...</span>
                        <button
                            onClick={() => handleChangePage(Math.ceil(filteredRows.length / rowsPerPage) - 1)}
                            className="pagination-number"
                        >
                            {Math.ceil(filteredRows.length / rowsPerPage)}
                        </button>
                        </>
                    )}
                </div>
                    <button
                    onClick={() => handleChangePage(page + 1)}
                    disabled={page >= Math.ceil(filteredRows.length / rowsPerPage) - 1}
                    className="pagination-arrow"
                    >
                    <img src={nextIcon} alt="Next" />
                    </button>
                </div>
            </div>
        </TableContainer>

        {openPdfModal && (
            <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 9999,
            display: 'flex', flexDirection: 'column'}}>
                {/* Header */}
                <div 
                    style={{
                        padding: '10px', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                    }}
                >
                    <Typography>{pdfName}</Typography>

                    <div>
                        {/* Download Button */}
                        <Button variant="contained"
                            onClick={() => {
                                const link = document.createElement('a');
                                link.href = pdfUrl;
                                link.download = pdfName || 'invoice.pdf';
                                link.click();
                            }}
                            sx={{ marginRight: '10px',borderRadius:'20px',backgroundColor:'#0065FF' }}
                        >
                            Download
                        </Button>

                        {/* Close Button */}
                        <Button variant="outlined" onClick={() => setOpenPdfModal(false)} sx={{ borderRadius:'20px' }}>
                            Close
                        </Button>
                    </div>
                </div>

                {/* PDF Preview */}
                <iframe
                    src={pdfUrl}
                    title="PDF Preview"
                    style={{ flex: 1, border: 'none' }}
                />
            </div>
        )}

        <Modal open={openMissedRidesDetails} onClose={() => setOpenMissedRidesDetails(false)}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90vw",
                    height: "90vh",
                    bgcolor: "#fff",
                    borderRadius: "16px",
                    boxShadow: 24,
                    outline: "none",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column", border:'1px solid #6B7280'
                }}
            >
                <Box sx={{
                        position: "absolute", top: 12, right: 8, zIndex: 10, display: 'flex', alignItems: 'center', gap: 1
                    }}
                >
                    <Button variant="contained" onClick={handleModalExportCsv} disabled={modalLoading || modalRows.length === 0}
                        sx={{
                            backgroundColor: '#0065FF', color: 'white', textTransform: 'none', borderRadius: '8px',
                            boxShadow: 'none', height: '36px', '&.Mui-disabled': { backgroundColor: '#BDBDBD', color: '#fff' }
                        }}
                    >
                        Export CSV
                    </Button>

                    <IconButton onClick={() => setOpenMissedRidesDetails(false)} sx={{ color: "#6B7280" }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box sx={{ flex: 1, overflow: "hidden", display: 'flex', flexDirection: 'column', p: 2, pt: 3 }}>
                    <Typography sx={{ fontSize: '20px', fontWeight: 500, mb: 2 }}>Engagement Details</Typography>
                    <Divider />
                    {modalLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <TableContainer className="table-container" sx={{ flex: 1, overflow: 'auto', maxHeight:'84vh' }}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        {modalColumns.map((col) => (
                                            // <TableCell key={col.id} align="center" className="table-header"
                                            //     style={{ minWidth: col.id === 'waypoints' ? '310px' : 'auto', whiteSpace: 'nowrap' }}
                                            // >
                                            //     {col.label}
                                            // </TableCell>

                                            <TableCell key={col.id} align="center" className="table-header"
                                                style={{ minWidth: col.id === 'waypoints' || col.id === 'pickup_address' || col.id === 'drop_address' ? '300px' : 'auto' }}>
                                                <TableSortLabel
                                                    active={modalOrderBy === col.id}
                                                    direction={modalOrderBy === col.id ? modalOrder : 'asc'}
                                                    onClick={() => handleModalRequestSort(col.id)}
                                                >
                                                    {col.label}
                                                </TableSortLabel>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {modalRows.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={modalColumns.length || 1} align="left">
                                                No data available
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        modalRows.map((row, index) => (
                                            <TableRow key={index}>
                                                {modalColumns.map((col) => (
                                                    <TableCell key={col.id} align="center">
                                                        {col.id === 'status' ? (
                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 'medium',
                                                                    color: getEngagementStatusColor(row.status),
                                                                    padding: '4px 8px',
                                                                    borderRadius: '4px',
                                                                    display: 'inline-block',
                                                                }}
                                                            >
                                                                {row[col.id]}
                                                            </Typography>
                                                        ) : (
                                                            row[col.id] || 'N/A'
                                                        )}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
            </Box>
        </Modal>

        <Snackbar
            open={snackbarOpen}
            autoHideDuration={2500}
            onClose={() => setSnackbarOpen(false)}
            message={snackbarMsg}
        />
    </div>
  );
};

export default DynamicRidesPanel;